import React from 'react';
import { ThemeProvider } from '@emotion/react';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

import './App.css';
import { VersionChecker } from '@panna/auth';
import RootRouter from './routes';
import theme from './theme';

function App() {
  return (
    <div className="App">
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <VersionChecker />
          <CssBaseline />
          <RootRouter />
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default App;
